import * as _ from 'lodash'
import React from 'react';
import componentServices from '../componentServices';
import globalRelay from '../globalRelay';
import util from '../util';
import enums from '../enum';
import { getModel, ModelCollection } from 'Scripts/store';

function getRowHref (item) {
	if (item.changeOrderKey) {
		return componentServices.router.splicePathSegments(5, 100, 'change-order', item.changeOrderKey);
	}
	else {
		return componentServices.router.splicePathSegments(5, 100);
	}
}

function getRowClasses (item) {
	const rowClasses:string[] = [];

	if (item.isChange) {
		rowClasses.push('changed');
		if (item.action === enums.trackableActions.Set) {
			rowClasses.push(item.rootKey === item.key ? 'new' : 'modified');
		}
		else {
			rowClasses.push('removed');
		}
	}

	return rowClasses;
}

const CabinetRow = ({ item, jobCost, rowClasses }) => {
	return (<tr className={ rowClasses.join(' ') }>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td >{ item.description || '-' }</td>
		<td className="list">{ util.formatAsCurrency(item.listPrice) }</td>
		<td className="factor">{ util.formatAsCurrency(item.costFactor) }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="sell" style={{ backgroundSize: '0px 0px' }}>{ util.formatAsCurrency(item.sellPrice) }</td>
		<td />
	</tr>);
};

const ClientUpgradRow = ({ item, jobCost, rowClasses }) => {
	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ item.workAreaKey ? jobCost.workAreas[item.workAreaKey].name : '-' }</td>
		<td >{ item.description || '-' }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="margin">{ (item.margin * 100).toFixed(2) }%</td>
		<td className="sell" style={{ backgroundSize: '0px 0px' }}>{ util.formatAsCurrency(item.sellPrice) }</td>
		<td />
	</tr>);
};

const CounterRow = ({ item, jobCost, rowClasses }) => {
	const { store } = componentServices;
	const vendor = item.vendorKey ? getModel({ store, collection: ModelCollection.vendors, key: item.vendorKey }) : null;

	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ item.workAreaKey ? jobCost.workAreas[item.workAreaKey].name : '-' }</td>
		<td>{ vendor ? vendor.name : '-' }</td>
		<td>{ item.referenceNumber || '-' }</td>
		<td >{ item.description || '-' }</td>
		<td className="centered"><input className="disabled" type="checkbox" checked={item.isOptional} /></td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="margin">{ (item.margin * 100).toFixed(2) }%</td>
		<td className="sell" style={{ backgroundSize: '0px 0px' }}>{ util.formatAsCurrency(item.sellPrice) }</td>
		<td />
	</tr>);
};

const GlassRow = ({ item, jobCost, rowClasses }) => {
	const glassType = item.glassTypeKey ? _.find(componentServices.store.getIn(['model', 'domainEntities']).glassTypes, { key: item.glassTypeKey }) : null;
	const doorSize = item.doorSizeKey ? _.find(componentServices.store.getIn(['model', 'domainEntities']).doorSizes, { key: item.doorSizeKey }) : null;

	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ glassType ? glassType.name : '-' }</td>
		<td>{ doorSize ? doorSize.name : '-' }</td>
		<td >{ item.description || '-' }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="quantity">{ item.quantity }</td>
		<td className="cost">{ util.formatAsCurrency(item.totalCost) }</td>
		<td className="margin">{ (item.margin * 100).toFixed(2) }%</td>
		<td className="sell" style={{ backgroundSize: '0px 0px' }}>{ util.formatAsCurrency(item.sellPrice) }</td>
		<td />
	</tr>);
};

const InstallationCustomRow = ({ item, jobCost, rowClasses }) => {
	const globalConfig = globalRelay.config!.withVariant(jobCost.companyVariant);
	const customUnit = item.unit ? _.find(globalConfig.jobCostSettings.installation.customUnits, { value: item.unit }) : null;

	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td >{ item.description || '-' }</td>
		<td >{ customUnit ? customUnit.label : '-' }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="quantity">{ item.quantity }</td>
		<td className="cost">{ util.formatAsCurrency(item.totalCost) }</td><td />
	</tr>);
};

const MiscRow = ({ item, jobCost, rowClasses }) => {
	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ item.workAreaKey ? jobCost.workAreas[item.workAreaKey].name : '-' }</td>
		<td >{ item.description || '-' }</td>
		<td className="centered"><input className="disabled" type="checkbox" checked={item.isOptional} /></td>
		<td>{ enums.jobCostLineItemReportingFlags.getDisplayName(item.contractVisibility) }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="margin">{ (item.margin * 100).toFixed(2) }%</td>
		<td className="cost">{ util.formatAsCurrency(item.sellPrice) }</td><td />
	</tr>);
};

const OutsideSupplierRow = ({ item, jobCost, rowClasses }) => {
	const { store } = componentServices;
	const vendor = item.vendorKey ? getModel({ store, collection: ModelCollection.vendors, key: item.vendorKey }) : null;

	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ vendor ? vendor.name : '-' }</td>
		<td>{ item.productName || '-' }</td>
		<td>{ item.workAreaKey ? jobCost.workAreas[item.workAreaKey].name : '-' }</td>
		<td >{ item.description || '-' }</td>
		<td className="centered"><input className="disabled" type="checkbox" checked={item.isOptional} /></td>
		<td>{ enums.jobCostLineItemReportingFlags.getDisplayName(item.contractVisibility) }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="quantity">{ item.quantity }</td>
		<td className="cost">{ util.formatAsCurrency(item.totalCost) }</td>
		<td className="margin">{ (item.margin * 100).toFixed(2) }%</td>
		<td className="cost">{ util.formatAsCurrency(item.sellPrice) }</td><td />
	</tr>);
};

const SubtradeRow = ({ item, jobCost, rowClasses }) => {
	const subtradeType = item.subTradeTypeKey ? _.find(componentServices.store.getIn(['model', 'domainEntities']).subTradeTypes, { key: item.subTradeTypeKey }) : null;

	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ subtradeType ? subtradeType.name : '-' }</td>
		<td>{ item.description || '-' }</td>
		<td className="centered"><input className="disabled" type="checkbox" readOnly={ true } checked={item.isOptional} /></td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="margin">{ (item.costFactor * 100).toFixed(2) }%</td>
		<td className="cost">{ util.formatAsCurrency(item.sellPrice) }</td><td />
	</tr>);
};

const SpecialOrderGlassRow = ({ item, jobCost, rowClasses }) => {
	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ item.itemNote || '-' }</td>
		<td>{ item.orderNote || '-' }</td>
		<td className='lwh'>{ `${item.width} x ${item.height}` }</td>
		<td>{ item.description || '-' }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="quantity">{ item.quantity }</td>
		<td className="cost">{ util.formatAsCurrency(item.totalCost) }</td>
		<td className="margin">{ (item.margin * 100).toFixed(2) }%</td>
		<td className="cost">{ util.formatAsCurrency(item.sellPrice) }</td><td />
	</tr>);
};

const WarehouseRow = ({ item, jobCost, rowClasses }) => {
	return (<tr className={rowClasses.join(' ')}>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td>{ item.productName || '-' }</td>
		<td>{ item.workAreaKey ? jobCost.workAreas[item.workAreaKey].name : '-' }</td>
		<td >{ item.description || '-' }</td>
		<td className="centered"><input className="disabled" type="checkbox" checked={item.isOptional} /></td>
		<td>{ enums.jobCostLineItemReportingFlags.getDisplayName(item.contractVisibility) }</td>
		<td className="cost">{ util.formatAsCurrency(item.cost) }</td>
		<td className="quantity">{ item.quantity }</td>
		<td className="cost">{ util.formatAsCurrency(item.totalCost) }</td>
		<td className="margin">{ (item.margin * 100).toFixed(2) }%</td>
		<td className="cost">{ util.formatAsCurrency(item.sellPrice) }</td><td />
	</tr>);
};

const ApplianceSpecRow = ({ item, jobCost, rowClasses }) => {
	return (<tr className={ rowClasses.join(' ') }>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td >{ item.name || '-' }</td>
		<td >{ item.value || '-' }</td>
		<td >{ item.applianceSize && item.applianceSize.width ? `${item.applianceSize.width} x ${item.applianceSize.height} x ${item.applianceSize.depth}` : '-' }</td>
		<td >{ item.openingSize && item.openingSize.width ? `${item.openingSize.width} x ${item.openingSize.height} x ${item.openingSize.depth}` : '-' }</td>
		<td >{ item.note || '-' }</td>
		<td />
	</tr>);
};

const SpecRow = ({ item, jobCost, rowClasses }) => {
	return (<tr className={ rowClasses.join(' ') }>
		<td />
		<td>{ util.dateHelper.formatDate(item.dateCreated, { userFriendly: true }) }</td>
		<td><a href={ getRowHref(item) } target="_blank">{ item.changeOrderKey ? jobCost.changeOrders[item.changeOrderKey].relayNumber : jobCost.relayNumber }</a></td>
		<td >{ item.name || '-' }</td>
		<td >{ item.value || '-' }</td>
		<td />
	</tr>);
};

export default class JobCostChangeHistoryModal extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.close = this.close.bind(this);
	}

	getStateFromProps () {
		const { item } = this.props;
		const state = _.assign({}, this.state);
		let listItem = item;

		state.itemModel = item.getModelName();
		state.items = [];

		while(listItem) {
			state.items.push(listItem);
			listItem = listItem.parent;
		}

		// switch (state.itemModel) {
		// case 'JobCostLineItem':
		// 	state.items = _.orderBy(_.filter(jobCost.lineItems, { rootKey: item.rootKey }), ['relayId'], ['desc']);
		// 	break;
		// case 'JobCostSpecification':
		// 	state.items = _.orderBy(_.filter(jobCost.specifications, { rootKey: item.rootKey }), ['relayId'], ['desc']);
		// 	break;
		// default:
		// 	break;
		// }

		return state;
	}

	close () {
		this.props.close();
	}

	getJobCostLineItemHead () {
		const { item } = this.props;

		switch (item.type) {
		case 'cabinet':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Description</td>
				<td className="list">List</td>
				<td className="factor">Factor</td>
				<td className="cost">Cost</td>
				<td className="sell">Sell</td>
				<td />
			</tr>);
		case 'client-upgrade':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Work Area</td>
				<td className="description">Description</td>
				<td className="cost">Cost</td>
				<td className="margin">Margin %</td>
				<td className="cost">Sell</td>
				<td />
			</tr>);
		case 'glass':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Type</td>
				<td>Door Size</td>
				<td>Cabinet Info</td>
				<td className="cost">Unit Cost</td>
				<td className="centered quantity">Quantity</td>
				<td className="cost">Cost</td>
				<td className="margin">Margin %</td>
				<td className="sell">Sell</td>
				<td />
			</tr>);
		case 'installation-custom':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Description</td>
				<td className="type">Type</td>
				<td className="cost">Cost Per</td>
				<td className="centered quantity">Quantity</td>
				<td className="cost">Cost</td>
				<td />
			</tr>);

		case 'misc':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Work Area</td>
				<td className="description">Description</td>
				<td className="centered">Optional</td>
				<td className="showOnContract">Show on Contract</td>
				<td className="cost">Cost</td>
				<td className="margin">Margin %</td>
				<td className="cost">Sell</td>
				<td />
			</tr>);
		case 'outside-supplier':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td className="vendor">Vendor</td>
				<td className="item">Item</td>
				<td className="workArea">Work Area</td>
				<td className="description">Description</td>
				<td className="centered">Optional</td>
				<td className="showOnContract">Show on Contract</td>
				<td className="cost">Unit Cost</td>
				<td className="quantity">Quantity</td>
				<td className="cost">Cost</td>
				<td className="margin">Margin %</td>
				<td className="cost">Sell</td>
				<td />
			</tr>);
		case 'solid-surface-counter':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Work Area</td>
				<td>Vendor</td>
				<td>Reference No.</td>
				<td>Description</td>
				<td className="centered">Optional</td>
				<td className="cost">Cost</td>
				<td className="margin">Margin %</td>
				<td className="cost">Sell</td>
				<td />
			</tr>);
		case 'special-order-glass':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Type</td>
				<td>Supplier</td>
				<td className="lwh">Door Size (WH)</td>
				<td>Cabinet Info</td>
				<td className="cost">Unit Cost</td>
				<td className="quantity">Quantity</td>
				<td className="cost">Cost</td>
				<td className="margin">Margin %</td>
				<td className="cost">Sell</td>
				<td />
			</tr>);
		case 'subtrade':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Category</td>
				<td>Description</td>
				<td className="centered">Optional</td>
				<td className="cost">Cost</td>
				<td className="margin">Markup %</td>
				<td className="sell">Sell</td>
				<td />
			</tr>);
		case 'warehouse':
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td className="item">Item</td>
				<td className="workArea">Work Area</td>
				<td className="description">Description</td>
				<td className="centered">Optional</td>
				<td className="showOnContract">Show on Contract</td>
				<td className="cost">Unit Cost</td>
				<td className="quantity">Quantity</td>
				<td className="cost">Cost</td>
				<td className="margin">Margin %</td>
				<td className="cost">Sell</td>
				<td />
			</tr>);
		default:
			break;
		}
	}

	getJobCostLineItemRows () {
		const { item, jobCost } = this.props;
		const { items } = this.state;
		const rows = _.map(items, i => {
			const rowClasses = getRowClasses(i);

			rowClasses.unshift('added');

			switch (item.type) {
			case 'cabinet':
				return <CabinetRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'client-upgrade':
				return <ClientUpgradRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'glass':
				return <GlassRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'installation-custom':
				return <InstallationCustomRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'misc':
				return <MiscRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'outside-supplier':
				return <OutsideSupplierRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'solid-surface-counter':
				return <CounterRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'special-order-glass':
				return <SpecialOrderGlassRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'subtrade':
				return <SubtradeRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			case 'warehouse':
				return <WarehouseRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			default:
				break;
			}
		});

		return rows;
	}

	getJobCostSpecificationHead () {
		const { item } = this.props;

		switch (item.group) {
		case enums.specGroups.Appliance:
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Name</td>
				<td>Value</td>
				<td>Size (WHD)</td>
				<td>Opening (WHD)</td>
				<td>Application Notes</td>
				<td />
			</tr>);
		default:
			return (<tr>
				<td />
				<td>Date</td>
				<td>Reference</td>
				<td>Name</td>
				<td>Value</td>
				<td />
			</tr>);
		}
	}

	getJobCostSpecificationRows () {
		const { item, jobCost } = this.props;
		const { items } = this.state;
		const rows = _.map(items, i => {
			const rowClasses = getRowClasses(i);

			rowClasses.unshift('added');

			switch (item.group) {
			case enums.specGroups.Appliance:
				return <ApplianceSpecRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;

			default:
				return <SpecRow key={ i.key } item={ i } jobCost={ jobCost } rowClasses={ rowClasses } />;
			}
		});

		return rows;
	}

	render () {
		const { itemModel } = this.state;
		const head = itemModel === 'JobCostLineItem' ? this.getJobCostLineItemHead() : this.getJobCostSpecificationHead();
		const rows = itemModel === 'JobCostLineItem' ? this.getJobCostLineItemRows() : this.getJobCostSpecificationRows();

		return (
			<div className="window">
				<header>
					<span>Change History</span>
					<button className="cancel" onClick={ this.close }><span>Close</span></button>
				</header>
				<div className="views">
					<div className="content in scrollable">
						<section>
							<div className="inner">
								<table className="compact" cellPadding="0" cellSpacing="0">
									<thead>
										{ head }
									</thead>
									<tbody>
										{ rows }
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
		);
	}
}